<template>
    <div>
        <div class="row">
            <div class="col  d-flex align-items-center">{{ email }}</div>
            <div class="col text-right">
                <button class="float-right btn-sm btn btn-light " v-if="email != ''"
                        @click="showModal">Edit
                </button>
                <button class="float-right btn-sm btn btn-light mr-2" v-if="verify_email ==0"
                        @click="verifyEmail">Verify
                </button>
            </div>
        </div>
        <button class="btn btn-outline-success" v-if="email == ''" id="show-btn" @click="showModal">Setup email
        </button>


        <b-modal ref="modalemail" hide-footer title="Setup Email">


            <div v-show="message !=''" class="alert alert-danger">{{message}}</div>

            <div class="form-group">
                <label for="email"><strong>New Email</strong></label>

                <input id="email" class="form-control" v-model="newemail">
                <small class="text-muted">This email is used to send order confirmation</small>
            </div>
            <button class="btn btn-success btn-block" @click="changeemail">Update</button>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "ChangeEmail",
        props: ['email', 'verify_email'],
        data: function () {
            return {
                message: '',
                newemail: ''
            }
        },

        methods: {
            showModal() {
                this.newemail = this.email
                this.$refs['modalemail'].show()
            },
            updateDone: function () {
                this.$emit('update', this.newemail);
            },
            verifyEmail: function () {
                let vm = this
                this.$http.post(this.$config.api + 'store/email-verify', {email: this.newemail}).then(function (res) {
                    vm.$swal(res.data.message);
                    //vm.verify_email = res.data.status
                    vm.$emit('verify', res.data.status);
                })
            },

            checkIsValidEemail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            changeemail: function () {
                let vm = this
                if (this.newemail == '') {
                    this.message = 'Please enter email'
                    return false
                }

                if (this.checkIsValidEemail(this.newemail) == false) {
                    this.message = 'Invalid email'
                    return false
                }

                this.$http.post(this.$config.api + 'store/email', {email: this.newemail}).then(function (res) {
                    if (res.data.status == false) {
                        vm.message = res.data.message
                    } else {
                        vm.message = ''
                        vm.$swal('Update email successfully')
                        vm.$emit('verify', 0);
                        vm.$refs['modalemail'].hide()
                        vm.updateDone()
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>